export var EWindowType;
(function (EWindowType) {
    EWindowType[EWindowType["MainGamepadUI"] = 0] = "MainGamepadUI";
    EWindowType[EWindowType["OverlayGamepadUI"] = 1] = "OverlayGamepadUI";
    EWindowType[EWindowType["Keyboard"] = 2] = "Keyboard";
    EWindowType[EWindowType["ControllerConfigurator"] = 3] = "ControllerConfigurator";
    EWindowType[EWindowType["VR"] = 4] = "VR";
    EWindowType[EWindowType["MainDesktopUI"] = 5] = "MainDesktopUI";
    EWindowType[EWindowType["DesktopLogin"] = 6] = "DesktopLogin";
    EWindowType[EWindowType["OverlayDesktopUI"] = 7] = "OverlayDesktopUI";
    EWindowType[EWindowType["SteamChinaReviewLauncher"] = 8] = "SteamChinaReviewLauncher";
})(EWindowType || (EWindowType = {}));
